import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import { unaryRpc } from "@redotech/rpc/definition";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const hasReturnableItems = unaryRpc({
  name: "hasReturnableItems",
  input: z.object({
    orderId: z.string(),
    returnType: createEnum(ReturnTypeEnum),
  }),
  output: z.boolean(),
});
